import './index.scss'
/* 表示表情对象 */
const emoji = require('@/config/emoji'),
  emojiObj = {}
Object.keys(emoji.obj).forEach(keyName => {
  emojiObj[keyName] = require(`../../../../static/faces/${ emoji.obj[keyName] }`)
})
/* 输入框换行的办法 */
const woohecc = {
  placeCaretAtEnd: function(el) {
    el.focus()
    if ( typeof window.getSelection != 'undefined'
      && typeof document.createRange != 'undefined' ) {
      let range = document.createRange()
      range.selectNodeContents(el)
      range.collapse(false)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    } else if ( typeof document.body.createTextRange != 'undefined' ) {
      let textRange = document.body.createTextRange()
      textRange.moveToElementText(el)
      textRange.collapse(false)
      textRange.select()
    }
  },
  getCursortPosition: function(ctrl) {
    let CaretPos = 0
    if ( document.selection ) {
      ctrl.focus()
      let Sel = document.selection.createRange()
      Sel.moveStart('character', - ctrl.value.length)
      CaretPos = Sel.text.length
    } else if ( ctrl.selectionStart || ctrl.selectionStart == '0' )
      CaretPos = ctrl.selectionStart
    return (CaretPos)
  }
}

/* 判断是否有重复的标签存在 */
const getLabelName = (childrens, index) => childrens[index - 1]['nodeName'] || ''
const judgeSameBr = (initVal, countVal, childrens) => {
  const brArr = []
  while ( countVal > 0 ) {
    brArr.push(getLabelName(childrens, initVal --))
    countVal --
  }
  return brArr.every(label => label === 'BR')
}

/* 排除模式 */
const excludeChar = char => {
  return /\n+/.test(char) ? char.replace(/\n+/, '<br/>') : char
}

/* 策略模式 */
const targetHooks = {
  'IMG': (result, child) => handleImg(result, child),
  '#text': (result, child) => result.push(excludeChar(child.data)),
  'BR': (result) => result.push('<br/>')
}

/* 判断是否有子类 */
const isChildren = parentDom => {
  return typeof parentDom.childNodes !== 'undefined' && Reflect.has(parentDom.childNodes, 'length') && parentDom.childNodes.length > 0
}

/* 处理图片的逻辑 */
const handleImg = (result, target) => {
  if ( target.dataset.img ) {
    result.push(target.dataset.img)
    return
  }
  result.push(target)
}

/* 处理子元素 */
const handleChildren = (result, target) => {
  const type = target.nodeName
  if ( targetHooks[type] ) {
    targetHooks[type](result, target)
  }

  if ( isChildren(target) ) {
    for ( let i = 0; i < target.childNodes.length; i ++ ) {
      handleChildren(result, target.childNodes[i])
    }
  } else {
    if ( Object.keys(targetHooks).includes(type) ) return
    if ( target.innerText ) result.push(excludeChar(target.innerText))
  }
}

/* 处理数组中多个BR 以及数组尾部Br */
const repeatBrHandle = result => {
  const label = '<br/>',
    newResult = []
  let len = result.length,
    curContent = '',
    i = 0,
    preContent = ''
  if ( len === 0 ) return []

  while ( result[len - 1] === label ) {
    result[len - 1] = undefined
    len --
  }
  for ( ; i < len; i ++ ) {
    curContent = result[i]
    if ( curContent === preContent && curContent === label ) {
      continue
    }
    preContent = curContent
    newResult.push(curContent)
  }
  return newResult
}

/* 正则批量替换 */
const emojiAllObj = emoji.reverseObj,
  emojiKeyList = Object.keys(emojiAllObj)
const regBatchUpdate = item => {
  item = item.replace(/<br\/>$/gi, '').replace(/^<br\/>/gi, '').replace(/<(?!\/?br\/?.+?>|\/?img.+?>)[^<>]*>/gi, '')
  let val = '',
    localIndex = - 1,
    keyList = JSON.parse(JSON.stringify(emojiKeyList))
  // eslint-disable-next-line no-cond-assign
  while ( val = keyList.pop() ) {
    localIndex = item.indexOf(val)
    while ( localIndex !== - 1 ) {
      item = item.replace(val, emojiAllObj[val])
      localIndex = item.indexOf(val)
    }
  }
  return item
}

/* 分割数组处理 */
const splitArrHandle = (result) => {
  let newResult = []
  const len = result.length
  if ( len === 0 ) return ''
  let i = 0,
    isObject = false,
    varTemp = '',
    item = null
  for ( ; i < len; i ++ ) {
    item = result[i]
    if ( typeof item === 'object' ) {
      isObject = true
      newResult.push(item)
      continue
    }
    item = item.replace(/^\s+$/gi, '')
    if ( !item ) continue
    if ( !isObject ) {
      varTemp = newResult.pop()
      newResult.push(`${ varTemp ? varTemp : '' }${ item }`)
    } else {
      newResult.push(item)
    }
    isObject = false
  }
  /* 分组后替换行首 以及行尾的空格 */
  newResult = newResult.map(item => {
    if ( typeof item === 'object' ) return item
    return regBatchUpdate(item)
  })
  return newResult
}

/* 引用添加处理 */
const quoteAddHandle = (result, quoteMsg) => {
  if ( !result ) result = [ '' ]
  let i = 0,
    item = null,
    addObj = null,
    isAddQuote = false
  const len = result.length,
    newArr = []
  for ( ; i < len; i ++ ) {
    item = result[i]
    if ( typeof item === 'object' ) {
      newArr.push({ type: 'img', content: item })
    } else {
      addObj = { langType: '1', type: 'text', content: item }
      if ( typeof quoteMsg === 'object' && quoteMsg !== null && Object.keys(quoteMsg).length > 0 && !isAddQuote ) {
        addObj['content'] = `${ item }###${ quoteMsg.msg }###${ quoteMsg.mid }`
        addObj['langType'] = '120'
        isAddQuote = true
      }
      newArr.push(addObj)
    }
  }
  if ( result.length === 0 && newArr.length === 0 ) {
    newArr.push({ type: 'text', content: '', langType: '1' })
  }
  return newArr
}

/* 获取输入的内容 */
const getContent = function(event) {
  const result = [],
    target = event ? event.target : document.querySelector('.richtext_input')
  let i = 0,
    child = null
  /* 循环遍历收集节点 */
  for ( ; i < target.childNodes.length; i ++ ) {
    child = target.childNodes[i]
    handleChildren(result, child)
  }
  let resultArr = splitArrHandle(repeatBrHandle(result))
  if ( this.quoteMsg.msg ) {
    resultArr = quoteAddHandle(resultArr, this.quoteMsg)
  } else {
    resultArr = quoteAddHandle(resultArr)
  }
  return resultArr
}

/* window keyDown事件 针对火狐单独处理 */
const editKeydown = () => {
  if ( navigator.userAgent.indexOf('Firefox') === - 1 ) return false
  const target = document.querySelector('.richtext_input'),
    childrens = target.childNodes,
    len = childrens.length
  if ( len >= 2 && judgeSameBr(len, 2, childrens) ) {
    target.removeChild(childrens[len - 1])
  }
}

/**
 * @author lihh
 * @description 导出自定义输入框编辑组件
 */
import close from '@/assets/images/closenotice.png'

export default {
  name: 'cu-richText',

  props: {
    // 默认宽度
    width: {
      type: String,
      default: '100%'
    },
    // 默认高度
    height: {
      type: String,
      default: '200px'
    },
    // 输入框提示
    placeholder: {
      type: String,
      default: '点击开启会话...,按回车键发送消息'
    },
    // 修改样式
    styles: {
      type: Object,
      default: () => {
      }
    },
    // 用来传递表情内容
    content: {
      type: Object,
      default: () => ({})
    },
    // 表示点击发送
    sendRandom: {
      type: String,
      default: ''
    },
    // 表示清空消息的random
    clearRandom: {
      type: Number,
      default: 0
    },
    // 引用消息
    quoteMsg: {
      type: Object,
      default: () => ({})
    }
  },

  // 监听
  watch: {

    /**
     * @author lihh
     * @description 表示选择表情 表情发生了变化
     */
    content: {
      handler(val) {
        if ( !val.emoji ) return
        this.resolveMsg(val.emoji)
      },
      deep: true
    },

    /**
     * @author lihh
     * @description 表示点击了发送按钮
     */
    sendRandom() {
      const target = document.querySelector('.richtext_input')
      if ( !target ) return
      this.$emit('send-input-message', getContent.call(this))
      this.clearData(target)
    },

    /**
     * @author lihh
     * @description 清空输入消息 以及引用消息
     */
    clearRandom() {
      this.clearData()
      this.clearQuoteMsgHandle()
    }
  },

  // 方法
  methods: {

    /**
     * @author lihh
     * @description 解析 将解析的图片 插入输入框中
     * @param content 表示解析的内容
     */
    resolveMsg(content) {
      if ( !content || !emojiObj[content] ) return
      const img = document.createElement('img'),
        target = document.querySelector('.richtext_input')
      if ( !target ) return
      const childrens = target.childNodes,
        len = childrens.length
      /* 判断如果图片之前有两个br的话 删除最后一个 */
      if ( len >= 2 && judgeSameBr(len, 2, childrens) ) {
        target.removeChild(childrens[len - 1])
      }
      img.src = emojiObj[content]
      img.setAttribute('data-img', content)
      target.appendChild(img)
      woohecc.placeCaretAtEnd(target)
    },

    /**
     * @author lihh
     * @description 表示清空数据
     * @param target 表示dom数据源
     */
    clearData(target) {
      target = (target && typeof target === 'object') ? target : document.querySelector('.richtext_input')
      if ( !target ) return
      target.focus()
      target.innerHTML = ''
    },

    /**
     * @author lihh
     * @description 表示回车事件
     * @param event 表示事件原对象
     * @returns {boolean}
     */
    enterHandle(event) {
      /* 判断是否是特殊的元素  组织默认事件 */
      const { target } = event
      if ( target.className.indexOf('richtext_input') === - 1 ) return
      /* 如果是ctrl键 + 回车键 进行换行 */
      if ( (event.ctrlKey || event.metaKey) && event.keyCode === 13 ) {
        /* 使用br来增加换行 */
        target.innerHTML = target.innerHTML + '<br>'.repeat(2)
        const dom = document.querySelector('.richtext_input'),
          childrens = dom.childNodes,
          len = childrens.length
        /* 判断如果图片之前有三个br的话 删除最后一个 */
        if ( len >= 3 && judgeSameBr(len, 3, childrens) ) {
          dom.removeChild(childrens[len - 1])
        }
        woohecc.placeCaretAtEnd(target)
        return false

        /* 如果是回车事件 直接发送 */
      } else if ( event.keyCode === 13 ) {
        this.$emit('send-input-message', getContent.call(this, event))
        this.clearData()
        event.preventDefault()
        return false
      }
      if ( navigator.userAgent.indexOf('Firefox') >= 0 ) {
        editKeydown()
      }
    },

    /**
     * @author lihh
     * @description 清空引用消息
     */
    clearQuoteMsgHandle() {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('update:quoteMsg', { msg: '', mid: '' })
    }
  },

  /* 组件被挂载钩子函数 */
  mounted() {
    let target = document.querySelector('.richtext_input')
    target.addEventListener('keydown', this.enterHandle)
    this.$once('hook:beforeDestroy', () => {
      target.removeEventListener('keydown', this.enterHandle)
      target = null
    })
  },

  render: function(h) {
    return (
      <div class = "richtext">
        <div class = "content richtext_input ios-user-select"
             data-placeholder = { this.placeholder }
             tabIndex = { 100 }
             style = { { height: `calc(${ this.height } - 30px)`, width: this.width, ...this.styles } }
             contentEditable = { true }>
        </div>
        <div class = "quote">
          {
            this.quoteMsg.msg ? (<div>
              <span class = "quote_span">{ this.quoteMsg.msg }</span>
              <img src = { close } alt = "" class = "quote_img" onClick = { this.clearQuoteMsgHandle }/>
            </div>) : (<span></span>)
          }

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/packages/RichText/CuRichText/index.jsx